export default {"src":"/_next/static/media/claude.6deb7f95.svg","height":2531,"width":2531,"blurWidth":0,"blurHeight":0};